export const JOB_STAGE = {
  INQUIRY: 'inquiry',
  SEARCH_REPORT: 'search-report',
  QUOTE: 'quote',
  ORDER: 'order',
  PURCHASE: 'purchase',
  QUALITY_REPORT: 'quality-report',
  SHIPMENT: 'shipment',
  TRACKING: 'tracking',
  BALANCE: 'balance',
};
